import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/pick-tickets/new/loading';

export const Route = createFileRoute('/_private/pick-tickets/new')({
  pendingComponent: Loading,
});
